var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightModeLinkArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4032_4257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.839966,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4032_4257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30667 21L6.67334 19.3666L17.8733 8.16665H7.84001V5.83331H21.84V19.8333H19.5067V9.79998L8.30667 21Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeLinkArrowIcon);
export default __webpack_public_path__ + "static/media/LightModeLinkArrowIcon.c4c9ede5b388d412566e2315f226b59a.svg";
export { ForwardRef as ReactComponent };